import React from 'react';
import { Route, useHistory } from 'react-router-dom';

const Redirect = ({ from, to }) => {
    const history = useHistory();

    const handleRender = () => {
        history.replace(to);
    }

    return <Route path={from} render={handleRender} />;
}

export default Redirect;
